import { useState } from "react";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useResetInputs } from "src/Contexts/hooks/useResetInputs";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { ModalDeleteCore } from "src/Pages/components";
import { api } from "src/shared/setup/API/api";

interface IModalChangeIsActiveAdministradora {
  modalIsActiveAdministradora: boolean;
  setModalIsActiveAdministradora: React.Dispatch<React.SetStateAction<boolean>>;
  isActiveAdministradora: boolean;
}

export const ModalChangeIsActiveAdministradora = ({
  setModalIsActiveAdministradora,
  modalIsActiveAdministradora,
  isActiveAdministradora,
}: IModalChangeIsActiveAdministradora) => {
  const { setAttTable } = useConfigPageContext();
  const { valuesInputsAdministradora } = useContextComissoes();
  const { handleGetAlert } = useLayoutMainContext();
  const { resetInputs } = useResetInputs();

  const [loading, setLoading] = useState(false);

  const handleIsActiveAdministradora = async () => {
    setLoading(true);

    if (!valuesInputsAdministradora.name)
      return handleGetAlert({ message: "Nome da administradora nao encontrado." });

    return api
      .put(`/comissoes/administradoras/status/${valuesInputsAdministradora.name}`, {
        name: valuesInputsAdministradora.name,
        is_active: isActiveAdministradora,
      })
      .then((res) => {
        handleGetAlert({
          message:
            res.data?.message ?? "Status da administradora atualizado com sucesso.",
        });
        setAttTable((item) => !item);
        resetInputs();
      })
      .catch((error) =>
        handleGetAlert({
          message:
            error.response?.data?.message ??
            "Erro ao atualizar status da administradora.",
        })
      )
      .finally(() => {
        setModalIsActiveAdministradora(false);
        setLoading(false);
      });
  };

  return (
    <ModalDeleteCore
      loading={loading}
      modalOpen={modalIsActiveAdministradora}
      no="Não, Cancelar"
      titlePrimary={`Você deseja ${
        !isActiveAdministradora ? "DESATIVAR" : "ATIVAR"
      } administradora ?`}
      titleSecondary={
        !isActiveAdministradora
          ? "Administradora não será REMOVIDA ! Apenas será desativado para uso do sistema."
          : "Administradora ficará disponível para uso do sistema."
      }
      yes={`Sim, ${!isActiveAdministradora ? "Desativar" : "Ativar"} !`}
      onClickFalse={() => setModalIsActiveAdministradora(false)}
      onClickTrue={() => handleIsActiveAdministradora()}
    />
  );
};
